<template>
	<form @submit.prevent="createTransport()">
		<div class="row">
			<div class="col-sm-8">
				<div class="row">
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="Transporter Name"
							label="Transporter Name"
							type="text"
							v-model="data.name"
							class="form-control form-control-lg dashInput"
							rules="required|min:3|max:50"
							@valError="inputError"
							@valSuccess="inputSuccess"
							:required="true"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="Contact Person Name"
							label="Contact Person Name"
							type="text"
							v-model="data.contactName"
							class="form-control form-control-lg dashInput"
							rules="required|min:3|max:50"
							@valError="inputError"
							@valSuccess="inputSuccess"
							:required="true"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="email"
							label="Email"
							type="email"
							v-model="data.email"
							class="form-control form-control-lg dashInput"
							rules="required|email|min:3|max:30"
							@valError="inputError"
							@valSuccess="inputSuccess"
							:required="true"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="contact"
							label="Contact Number"
							type="Number"
							v-model="data.phone"
							class="form-control form-control-lg dashInput"
							rules="required|min:10|max:10"
							@valError="inputError"
							@valSuccess="inputSuccess"
							:required="true"
							:min="6000000000"
							:max="9999999999"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="address"
							label="Address"
							type="text"
							v-model="data.address"
							class="form-control form-control-lg dashInput"
							rules="required"
							@valError="inputError"
							@valSuccess="inputSuccess"
							:required="true"
						/>
					</div>
					<div class="form-group col-sm-6 mb-4">
						<BaseInput
							name="GST Number"
							label="Transporter GST Number"
							type="text"
							v-model="data.gstNumber"
							class="form-control form-control-lg dashInput"
							rules="required|min:12|max:12"
							@valError="inputError"
							@valSuccess="inputSuccess"
							:required="true"
						/>
					</div>
					<h5
						class="col-md-12 custom-dark-text custom-rounded-15 shadow-lg mb-4 d-flex justify-content-between align-items-center py-3"
					>
						Vehicle
						<button
							type="button"
							@click="addVehicle()"
							class="btn btn-danger btn-sm"
						>
							Add Vehicle
						</button>
					</h5>
					<div
						v-for="vehicleObj in vehicleCount.component"
						:key="vehicleObj.id"
						class="form-group col-sm-12 mb-5"
					>
						<div class="row border border-warning mx-2 py-1">
							<div class="form-group col-sm-4 mb-2">
								<BaseMultiSelect
									@update:value="setCountry"
									:options="multiSelectState.countriesSelect"
									rules="required"
									name="Country"
									:componentId="vehicleObj.id"
									@valError="inputError"
									@valSuccess="inputSuccess"
								/>
							</div>
							<div class="form-group col-sm-4 mb-2">
								<BaseMultiSelect
									@change:value="getCities"
									@update:value="setCity"
									:options="multiSelectState.citiesSelect"
									rules="required"
									name="City"
									:componentId="vehicleObj.id"
									@valError="inputError"
									@valSuccess="inputSuccess"
								/>
							</div>

							<div class="form-group col-sm-4 mb-2 position-relative">
								<BaseMultiSelect
									@update:value="setVehicle"
									:options="multiSelectState.vehicleSelect"
									rules="required"
									name="Vehicle Type"
									mode="tags"
									:componentId="vehicleObj.id"
									@valError="inputError"
									@valSuccess="inputSuccess"
								/>
								<span
									v-if="vehicleObj.id !== 1"
									@click="removeVehicle(vehicleObj.id)"
									class="mx-2 position-absolute top-0 start-100 me-2 translate-middle badge rounded-pill bg-danger cursor-pointer"
									>x</span
								>
							</div>
						</div>
					</div>

					<div class="form-group col-sm-12 mb-5">
						<label for="cityDataList" class="form-label custom-dark-text"
							>Description</label
						>
						<textarea
							class="form-control form-control-lg"
							v-model="data.description"
						></textarea>
					</div>
					<div class="col-sm-12">
						<div class="form-check form-switch">
							<input
								class="form-check-input"
								v-model="image.enabled"
								type="checkbox"
								id="imageCheck"
							/>
							<label class="form-check-label text-dark" for="imageCheck"
								>Upload transport image</label
							>
						</div>
					</div>

					<div v-if="image.enabled" class="col-sm-12">
						<BaseImageUpload urlParam="transporters" @images-data="setImage" />
					</div>

					<div
						class="form-group col-sm-6 mt-2"
						:class="formState.disable ? 'cursor-disabled' : 'cursor-pointer'"
					>
						<BaseButton
							class="btn btn-primary form-control form-control-lg"
							type="submit"
							label="Add Transport"
							:disabled="formState.disable"
							:loading="formState.isLoading"
						/>
					</div>
				</div>
			</div>
			<div class="col-sm-4 px-4">
				<h4 class="text-dark fs-4">Global Trip Holidays</h4>
				<p class="text-dark">
					Contacts are your customers you interact with in pursuit of a business
					opportunity.
				</p>
			</div>
		</div>
	</form>
</template>
<script>
	import { reactive, inject, watch } from "vue";
	import API from "@/config/api";
	import toast from "@/config/toast";
	import Helper from "@/helpers/dataHelper";
	import FormCheck from "@/helpers/formCheckHelper";
	import BaseInput from "./BaseInput.vue";
	import BaseButton from "./BaseButton.vue";
	import BaseMultiSelect from "./BaseMultiSelect.vue";
	import BaseFileInput from "./BaseFileInput.vue";
	import BaseImageUpload from "./BaseImageUpload.vue";

	export default {
		name: "TransportCreate",
		components: {
			BaseInput,
			BaseButton,
			BaseMultiSelect,
			BaseFileInput,
			BaseImageUpload,
		},
		setup: () => {
			console.log("Transport Create Component");
			const masterStore = inject("masterStore");

			const data = reactive({
				name: null,
				contactName: null,
				email: null,
				phone: null,
				address: null,
				gstNumber: null,
				vehicleData: [],
				description: null,
				images: [],
			});
			const formState = reactive({
				isLoading: false,
				disable: true,
			});

			const nullable = ["description", "remark", "images"];

			const multiSelectState = reactive({
				countries: [],
				countriesSelect: [],
				selectedCountry: {
					id: null,
					name: null,
				},
				cities: [],
				citiesSelect: [],
				states: [],
				vehicles: [],
				vehicleSelect: [],
			});

			//dynamic vehicle input State
			let vehicleCount = reactive({
				component: [
					{
						id: 1,
						country: {},
						city: {},
						vehicles: [],
					},
				],
			});

			const changeFormLoadingState = () =>
				(formState.isLoading = !formState.isLoading);

			const createTransport = async () => {
				changeFormLoadingState();
				formState.disable = true;

				// if (validation.invalid.length) {
				// 	toast.error("Incomplete form", true);
				// 	changeFormLoadingState();
				// 	return;
				// }

				try {
					await API.privateRequest.post("transports", data);
					toast.success(
						{ message: "Transport created!", position: "topRight" },
						true,
					);
					changeFormLoadingState();
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}

					toast.error(message, true);
					changeFormLoadingState();
					formState.disable = false;
				}
			};

			// event handler for input validation event
			const inputError = (input) => {
				let check = FormCheck.valError(input, data, nullable);
				formState.disable = check;
			};

			const inputSuccess = (input) => {
				let check = FormCheck.valSuccess(input, data, nullable);
				formState.disable = check;
			};

			// ! Country Functions
			const getCountries = async () => {
				try {
					const response = await Helper.getCountries();
					const countries = response;
					multiSelectState.countries = countries;
					multiSelectState.countriesSelect = countries.map((country) => {
						return { label: country.name, value: country.id };
					});
				} catch (error) {
					console.log(error);
				}
			};
			getCountries();

			const setCountry = (dataObj) => {
				let country;
				if (dataObj.id) {
					// ? finding selected city data
					country = multiSelectState.countries.filter(
						(country) => country.id === dataObj.id,
					);
				} else {
					country = [{ name: null, id: 0 }];
				}

				multiSelectState.selectedCountry.id = country[0].id;
				multiSelectState.selectedCountry.name = country[0].name;
				// ? changing state value without re-render
				vehicleCount.component.map((item) => {
					if (item.id === dataObj.componentId) {
						item.country = { name: country[0].name, id: country[0].id };
						addToVehicles();
					}
				});
			};

			// ! City Functions

			const getCities = async (cityObj = false) => {
				let data = {};
				let country;

				if (cityObj?.componentId) {
					country = vehicleCount.component.map((item) => {
						if (item.id === cityObj.componentId) {
							if (item.country?.name) return item.country.name;
						}
					});
					if (country.length) data.countryName = country[0];
				}

				if (cityObj?.name && cityObj?.name.length < 3) return;
				else if (cityObj?.name && cityObj?.name.length > 3)
					data.name = cityObj.name;

				if (multiSelectState.selectedCountry.name) {
					data.countryName = multiSelectState.selectedCountry.name;
				} else if (!multiSelectState.selectedCountry.name && !cityObj) {
					return;
				}

				try {
					const cities = await Helper.getCities(data);

					multiSelectState.cities = [...cities];

					const changeFormat = cities.map((city) => {
						return {
							label: `${city.name} (${city.state_name})`,
							value: city.id,
						};
					});

					multiSelectState.citiesSelect = [...changeFormat];
				} catch (error) {
					console.log(error);
				}
			};

			watch(
				() => multiSelectState.selectedCountry,
				(newValue, prevValue) => {
					if (multiSelectState.selectedCountry.name) {
						getCities();
					}
				},
				{ deep: true },
			);

			const setCity = (dataObj) => {
				let city;
				if (dataObj.id) {
					// ? finding selected city data
					city = multiSelectState.cities.filter(
						(city) => city.id === dataObj.id,
					);
				} else {
					city = [{ name: null, id: 0, state_name: null }];
					return;
				}

				// ? changing state value without re-render
				vehicleCount.component.map((item) => {
					if (item.id === dataObj.componentId) {
						item.city = {
							name: city[0].name,
							id: city[0].id,
							state_name: city[0].state_name,
						};
						addToVehicles();
					}
				});
			};

			const getVehicles = async () => {
				try {
					const response = await API.privateRequest.get("vehicles");
					const vehicles = response.data.data.map((vehicle) => ({
						value: vehicle._id,
						label: vehicle.vehicleType,
					}));
					multiSelectState.vehicles = response.data.data;
					multiSelectState.vehicleSelect = vehicles;
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}

					toast.error(message, true);
				}
			};
			getVehicles();

			const setVehicle = (dataObj) => {
				if (!dataObj.componentId) return;
				let ids = Object.values(dataObj.id);
				vehicleCount.component.map((item) => {
					if (item.id === dataObj.componentId) {
						ids.map((id) => {
							if (item.vehicles.includes(id)) {
								return;
							}
							item.vehicles.push(id);
							addToVehicles();
						});
					}
				});
				return;
			};

			//? adding component state to main(data) state

			const addToVehicles = () => {
				//console.log("adding to main state:: :: ::: ::: :");

				let componentData = vehicleCount.component.map((item) => {
					let cityCheck = Object.keys(item.city);
					let countryCheck = Object.keys(item.country);
					let vehicleCheck = item.vehicles.length;
					let dataItem;
					if (cityCheck.length && countryCheck.length && vehicleCheck) {
						dataItem = { ...item };
						delete dataItem.id;
						return dataItem;
					} else {
						console.log("unable to add to vehicleData:");
					}
				});
				componentData = componentData.filter(Boolean);
				data.vehicleData = [...componentData];
			};

			const addVehicle = () => {
				let vehicles = vehicleCount.component;
				const id = vehicles[vehicles.length - 1].id + 1;
				vehicles = [...vehicles, { id, country: {}, city: {}, vehicles: [] }];
				vehicleCount.component = vehicles;
			};

			const removeVehicle = (id) => {
				let vehicle = vehicleCount.component;
				vehicle = vehicle.filter((item) => item.id !== id);
				vehicleCount.component = vehicle;
			};

			const image = reactive({
				enabled: false,
			});

			const setImage = (images) => {
				if (!images.length) return;
				data.images = [...data.images, ...images];
				formState.disable = false;
			};

			return {
				data,
				image,
				formState,
				multiSelectState,
				vehicleCount,
				createTransport,
				inputError,
				inputSuccess,
				setCountry,
				getCities,
				setCity,
				setVehicle,
				addVehicle,
				removeVehicle,
				setImage,
			};
		},
	};
</script>
